import { Header } from './Header';
import { Footer } from './Footer';
import { MobileStickyBar } from './MobileStickyBar';
import { LeadCapturePopup } from './LeadCapturePopup';

export const Layout = ({ children }) => {
  return (
    <div className="min-h-screen bg-[#0a0a0a]">
      <div className="noise-overlay" />
      <Header />
      <main className="pt-20 pb-16 lg:pb-0">
        {children}
      </main>
      <Footer />
      <MobileStickyBar />
      <LeadCapturePopup />
    </div>
  );
};
